export default __webpack_public_path__ + "static/media/Flyers.7e4c0e16.png";